"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CircleCheck, ChartLine, Shield } from "lucide-react";
export default function KeyFeatures() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: CircleCheck,
    title: "95% Scope Gap Reduction",
    description: "AI-powered detection identifies and eliminates project scope gaps before they become costly issues.",
    ref: ref1,
    isVisible: isVisible1,
    delay: 0
  }, {
    icon: ChartLine,
    title: "Real-Time Project Vitals",
    description: "Monitor critical project metrics and performance indicators in real-time for proactive decision-making.",
    ref: ref2,
    isVisible: isVisible2,
    delay: 100
  }, {
    icon: Shield,
    title: "Secure Egnyte Integration",
    description: "Seamlessly integrate with Egnyte for secure document management and compliance tracking.",
    ref: ref3,
    isVisible: isVisible3,
    delay: 200
  }];
  return <section id="key-features" className="bg-background py-16 sm:py-20 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Key Features
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Powerful AI-driven capabilities designed to transform your construction project management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => {
          const IconComponent = feature.icon;
          return <div key={i} data-index={i} ref={feature.ref} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: feature.isVisible ? 1 : 0,
            transform: feature.isVisible ? "translateY(0)" : "translateY(20px)",
            transitionDelay: feature.isVisible ? `${feature.delay}ms` : "0ms"
          }}>
                <Card className="h-full hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border border-border">
                  <CardHeader className="text-center pt-8">
                    <div className="flex justify-center mb-4">
                      <div className="rounded-full bg-primary/10 p-4">
                        <IconComponent className="w-8 h-8 text-primary" strokeWidth={2} />
                      </div>
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="text-center pb-8">
                    <CardDescription className="text-base text-muted-foreground leading-relaxed">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}